// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD8xP36cErM-v1D6agJm6F6YZnu4Dl0j2o",
  authDomain: "nextloop-31377.firebaseapp.com",
  projectId: "nextloop-31377",
  storageBucket: "nextloop-31377.appspot.com",
  messagingSenderId: "614447700005",
  appId: "1:614447700005:web:aa37956471fa959ebb47cc",
  measurementId: "G-Z82NVJ7165"
};



export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
